import axios from "axios";
import { logtoClient } from "../Logto";
const { REACT_APP_API_URL: API_URL } = process.env;
export const getOrgInfo = async (orgId: string): Promise<unknown> => {
  const authToken = await logtoClient.getOrganizationToken(orgId);
  const { data } = await axios.get(`${API_URL}/api/v1/organization/${orgId}`, {
    headers: {
      Authorization: `Bearer ${authToken}`,
    },
  });
  return data?.data || {};
};
